import React from 'react';

const {
    Provider: ChannelServiceProvider,
    Counsumer: ChannelServiceConsumer
} = React.createContext();


export {ChannelServiceProvider, ChannelServiceConsumer};
